import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserPreference } from "../../utilities/common";
import { handleBlockingPackages, openBlockingPackages } from '../../reducers/uiSlice';
import { getHoldingKey, handleReturnedBlockBatch } from "../../actions/hpmAction";
import HoldingReport from './HoldingReport';
import GetHoldingKey from './GetHoldingKey';
import { makeStyles } from '@material-ui/core/styles';
import UniDialog from '../Common/UniDialog';
import Grid from '@material-ui/core/Grid';
import AddHoldingPackages from './AddHoldingPackages';
import GetHoldingReport from './GetHoldingReport';
import CancelBatch from './CancelBatch';
import { useTranslation } from 'react-i18next';
import AddHoldingByBags from './AddHoldingByBags';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        height: '80vh'
    },
    container: {
        display: 'flex',
        width: '100%'
    }
}));

function HoldingPackagesManagement() {
    const classes = useStyles();
    const {t} = useTranslation('holdingPackagesManagement');
    const dispatch = useDispatch();
    const openModal = useSelector(openBlockingPackages);
    const [report, setReport] = useState([]);
    const [summary, setSummary] = useState([]);
    const [blockBatch, setBlockBatch] = useState('');
    const [detainedReason, setDetainedResaon] = useState('');
    const handleDetainedResaon = (detainedReason) => {
        setDetainedResaon(detainedReason);
    }

    useEffect(() => {
        if(openModal) {
            dispatch(getHoldingKey());
            dispatch(handleReturnedBlockBatch(''))
        }
    }, [openModal])

    return (
        <UniDialog
            title={t('title_holding_packages')}
            fullWidth
            maxWidth='lg'
            disableDefaultButtons
            open={openModal}
            onClose={handleClose}
        >
            <Grid 
                container 
                alignItems="center"
                justify="center"
                className={classes.container}
            >
                <Grid item xs={4} style={{padding: 16}}>
                    <AddHoldingPackages
                        handleDetainedResaon={handleDetainedResaon}
                        detainedReason={detainedReason}/>
                </Grid>
                <Grid 
                    item xs={8} 
                    style={{
                        padding: 16, 
                        display: 'flex', 
                        flexDirection: 'column'
                }}>
                    <div style={{ marginBottom: 20 }}>
                        <GetHoldingKey/>
                    </div>
                    <div style={{ marginBottom: 20 }}>
                        <CancelBatch />
                    </div>
                    <div style={{ marginBottom: 20 }}>
                        <GetHoldingReport 
                            handleReport={handleReport} 
                            handleSummary={handleSummary}
                            handleBlockBatch={handleBlockBatch}
                        />  
                    </div>
                    <div>
                        <AddHoldingByBags
                            detainedReason={detainedReason}
                            openComponent={openModal}/>
                    </div>
                </Grid>
            </Grid>
            <Grid 
                container 
                alignItems="center"
                justify="center"
                className={classes.container}
            >
                 <Grid item xs={12} style={{padding: 16}}>
                    <HoldingReport report={report} summary={summary} blockBatch={blockBatch}/>
                </Grid>    
            </Grid>         
        </UniDialog>
    );

    /**
     * close the dialog
    */
    function handleClose() {
        localStorage.setItem('blockBatch', '');
        setReport([]);
        setSummary([]);
        dispatch(handleBlockingPackages(false))
    }
    function handleReport(report) {
        setReport(report);
    }
    function handleSummary(summary) {
        setSummary(summary);
    }
    function handleBlockBatch(blockBatch) {
        setBlockBatch(blockBatch)
    }
}

export default HoldingPackagesManagement;